import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ProductService } from "../../services/product/product.service";
import { ProductAttributes } from "@models/product.model";

@Component({
    selector: "app-review-success",
    templateUrl: "./review-success.component.html",
    styleUrl: "./review-success.component.scss",
    standalone: false,
})
export class ReviewSuccessComponent implements OnInit {
    public productId!: number;
    public product!: ProductAttributes;

    constructor(
        private route: ActivatedRoute,
        private productService: ProductService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.productId = params["id"];
            if (this.productId) {
                //allow fetching product even if it is inactive or Active
                this.productService.getProductById(this.productId, true).subscribe((response) => {
                    this.product = response;
                });
            }
        });
    }

    public navigateReviewListPage(): void {
        this.router.navigate(["/account/trackOrder"]);
    }
}
